module.exports = __webpack_public_path__ + "static/media/Boreal-Besties6.82cc6605.jpg";